export default __webpack_public_path__ + "static/stage-2_8-c639bac223e8455265f13c8e0fc63acf.jpg";